const Mixin = {
  data () {
    return {
      siteMetaPixel: null,
      fbPixelAdded: false
    }
  },
  methods: {
    wathInfoSiteMetaPixel (nVal, oVal) {
      if (nVal.site_meta_pixel) {
        this.siteMetaPixel = nVal.site_meta_pixel
        this.appendFacebookPixel()
      }
    },
    appendFacebookPixel () {
      if (this.fbPixelAdded) return;

      this.fbPixelAdded = true;

      (function(f,b,e,v,n,t,s) {
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
      })(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');

      if (window.fbq) {
        window.fbq('init', this.siteMetaPixel);
        window.fbq('track', 'PageView');
      }

      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${this.siteMetaPixel}&ev=PageView&noscript=1"/>`;
      document.body.appendChild(noscript);
    }
  }
}

export default Mixin
